import React from 'react'
import { LegacyButton } from '../button'
import { useRouter } from 'next/router'

interface ModalProps {
  copy: string
  cta?: string
  heading: string
  onClose?: () => void
  allowClickOutside?: boolean
}
const ErrorModal: React.FC<ModalProps> = ({
  heading,
  copy,
  cta,
  onClose,
  allowClickOutside,
}) => {
  const router = useRouter()

  const handleClose = () => {
    if (onClose) {
      onClose()
    } else {
      window.location.reload()
    }
  }

  const icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <rect width="48" height="48" rx="24" fill="#CC3B33" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.2569 17.0988C23.0215 15.7395 24.9786 15.7395 25.7432 17.0988L31.3235 27.0194C32.0735 28.3526 31.11 29.9999 29.5804 29.9999H18.4198C16.8901 29.9999 15.9267 28.3526 16.6766 27.0194L22.2569 17.0988ZM25 27C25 27.5523 24.5523 28 24 28C23.4477 28 23 27.5523 23 27C23 26.4477 23.4477 26 24 26C24.5523 26 25 26.4477 25 27ZM24 19C23.4477 19 23 19.4477 23 20V23C23 23.5523 23.4477 24 24 24C24.5523 24 25 23.5523 25 23V20C25 19.4477 24.5523 19 24 19Z"
        fill="white"
      />
    </svg>
  )

  return (
    <div
      className="relative z-10"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75 bg-green"
        role="presentation"
        onClick={allowClickOutside ? handleClose : undefined}
        onKeyDown={
          allowClickOutside
            ? (e) => e.key === 'Enter' && handleClose()
            : undefined
        }
      />

      <div className="fixed z-10 w-[560px] overflow-y-auto transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
        <div className="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
          <div className="font-ttHovesMedium max-w-[360px] md:max-w-none relative overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:w-full sm:max-w-lg">
            <div className="px-4 pt-6 pb-4 bg-white sm:p-6 sm:pb-4">
              <div className="flex-col items-center justify-center sm:flex">
                <div
                  className={`flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-red-100 rounded-full sm:mx-0 sm:h-10 sm:w-10 `}
                >
                  {icon}
                </div>
                <h1 className="flex text-center justify-center mt-5 mb-2 font-ttHovesMedium text-green text-[1.25rem] leading-6 ">
                  {heading}
                </h1>
                <p className="text-center w-[90%] mx-auto text-green font-ttHovesRegular">
                  {copy}
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-3 mt-2 items-center justify-center w-[90%] mx-auto px-4 mb-6">
              {cta ? (
                <LegacyButton
                  customStyles="w-[80%]"
                  dark
                  text={cta}
                  onClickCallback={() => {
                    handleClose()
                  }}
                />
              ) : (
                <LegacyButton
                  customStyles="w-[80%]"
                  dark
                  text="Go Back"
                  onClickCallback={() => {
                    router.back()
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ErrorModal
